/** TBD on backend — update when the real event name is finalised. */
export const MVOICE_RECORD_NUMBER_EVENT = "MVoiceRecordNumberReady";
